<!-- The host is the point on the ceiling the lamp hangs from -->
<div class="absolute -left-1.25 h-[calc(var(--drop)*var(--spacing))] w-2.5 bg-linear-to-r from-[#2a2f3b] via-[#6b7386] to-[#2a2f3b]"></div>

<!-- Where the lamp turns around -->
<div class="absolute top-[calc(var(--drop)*var(--spacing))]">
  <div class="ease-in-out-cubic absolute transition-transform duration-900" [style.transform]="'rotate(' + aim() + 'deg)'">
    <!-- Rotated from script while partying -->
    <div #sweep class="absolute">
      <div
        class="anim-sway absolute [animation-delay:calc(var(--offset)*-1.9s)] [animation-duration:calc(5s+var(--offset)*0.7s)] motion-reduce:animate-none"
      >
        <!-- A cone of light, coming out of the lens so it turns along with the lamp -->
        <div
          class="absolute top-31 -left-80 h-420 w-160 bg-linear-to-b from-[color:color-mix(in_srgb,var(--color)_55%,transparent)] via-[color:color-mix(in_srgb,var(--color)_22%,transparent)] via-40% to-transparent to-92% blur-md transition-opacity duration-1200 [clip-path:polygon(43%_0,57%_0,100%_100%,0_100%)]"
          [class]="beamClass()"
        ></div>

        <!-- The bracket holding the lamp -->
        <div class="absolute top-0 -left-14.5 h-16 w-29 rounded-t-xl border-9 border-t-12 border-b-0 border-[#3a404d]"></div>

        <div
          class="absolute top-4.5 -left-11.5 h-27 w-23 rounded-[20px_20px_14px_14px] bg-linear-to-r from-[#1d2129] via-[#4c5466] via-38% to-[#15181e] shadow-[inset_0_10px_0_rgb(255_255_255/0.12)]"
        >
          <div
            class="anim-breathe absolute -inset-x-1 -bottom-3 h-7.5 rounded-full bg-radial from-white from-22% via-(--color) via-55% to-[color:color-mix(in_srgb,var(--color)_60%,black)] transition-[filter,box-shadow] duration-1200 [animation-delay:calc(var(--offset)*-0.8s)] [animation-duration:calc(2.4s+var(--offset)*0.3s)] motion-reduce:animate-none"
            [class]="lensClass()"
          >
            <!-- Flickers while partying -->
            <div
              class="absolute -inset-x-[15%] -inset-y-[40%] rounded-full bg-radial from-white from-25% via-(--color) via-50% to-transparent to-72% opacity-0 [animation-delay:calc(var(--offset)*0.07s)] motion-reduce:animate-none"
              [class.anim-strobe]="isPartying()"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="absolute -top-3.25 -left-3.25 size-6.5 rounded-full bg-radial-[at_35%_35%] from-[#9aa3b5] to-[#2f3542]"></div>
</div>
